import { render, staticRenderFns } from "./SettingGroup.vue?vue&type=template&id=8b71b24e&scoped=true"
import script from "./SettingGroup.vue?vue&type=script&lang=js"
export * from "./SettingGroup.vue?vue&type=script&lang=js"
import style0 from "./SettingGroup.vue?vue&type=style&index=0&id=8b71b24e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b71b24e",
  null
  
)

export default component.exports